// @ts-nocheck
export default (theme: any) => !theme.name;
